export default __webpack_public_path__ + "static/i-MedicalCard Elite_Annual Contribution Rates-99d57418a7e7f1d71e117ed9f27d03aa.pdf";